import React, { useState } from 'react';

import { FormControl } from '@material-ui/core';
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Input from '../../../../components/forms/Input';

interface Props {
    onSearch: (searchText: string) => void;
}

const StyledForm = styled.form`
    margin-right: 1rem;
`;

const StyledButton = styled(Button)`
    margin-right: 4px;

    svg {
        max-width: 20px;
    }
`;

const UserSearchForm: React.FC<Props> = ({ onSearch }) => {
    const [searchText, setSearchText] = useState<string>('');

    const { t } = useTranslation('admin_settings');

    const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(event.target.value);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSearch(searchText);
    };

    return (
        <StyledForm onSubmit={handleSubmit}>
            <FormControl>
                <Input
                    name="search"
                    label={t('classes.search')}
                    onChange={handleChangeSearch}
                    value={searchText}
                    endAdornment={
                        <StyledButton variant={'contained'} type="submit">
                            <Icon path={mdiMagnify} />
                        </StyledButton>
                    }
                />
            </FormControl>
        </StyledForm>
    );
};

export default UserSearchForm;
